const SITE = (process.env.NEXT_PUBLIC_SITE_BASE_URL || 'https://juicystarz.com').replace(/\/$/, '');

export function profileUrl(stageNameNormalized: string): string {
  return `${SITE}/u/${encodeURIComponent(stageNameNormalized)}`;
}

export function metroUrl(metroSlug: string, stateAbbr: string): string {
  return `${SITE}/${metroSlug.toLowerCase()}-${stateAbbr.toLowerCase()}`;
}

export function stateUrl(stateAbbr: string): string {
  return `${SITE}/${stateAbbr.toLowerCase()}`;
}

export function categoryMetroUrl(category: string, metroSlug: string, stateAbbr: string): string {
  return `${SITE}/c/${category.toLowerCase()}/${metroSlug.toLowerCase()}-${stateAbbr.toLowerCase()}`;
}

export function siteBase(): string {
  return SITE;
}
